import { Record } from 'immutable';

export const FullReportMp = new Record({
  id: null,
  isPending: false,
  error:null,
  items: {items:{}}
});
